export default (tracker) => ({
  async retailer(data) {
    await tracker.track('Warranty Activation Retailer Selected', data)
  },

  async start(data) {
    await tracker.track('Warranty Activation Started', data)
  },

  async complete(data) {
    await tracker.track('Warranty Activation Complete', data)
  },
})
